<template>
<div class="marginb20" v-for="item in localCoupon">
    <div class="pos-r flex-container vfull couponsList" style="min-height: 95px"
         :class="[getColor(item), item.xiaowangOnly && isHybrid ? 'xiaowang-only' : null]">
        <div class="flex-container-col center text-white couponHeadContainer pos-r"
             style="min-width: 100px;max-width: 100px;overflow:hidden">
            <div class="pos-a top0 left0 fs-10"
                 style="background: #FC273F;padding: 0 5px;border-radius: 0 0 5px 0;"
                 v-if="item.upcoming">即将过期</div>
            <!-- 金额显示 -->
            <div class="">
                <span style="font-size:33px">
                    <span class="fs-20 lh-1" v-if="item.subTitle.symbol">{{item.subTitle.symbol}}</span><span
                        class="lh-1">{{item.subTitle.main}}</span><span class="fs-12 lh-1"
                                                                        v-if="item.subTitle.main">{{item.subTitle.desc}}</span>
                </span>
            </div>
            <!-- 限制条件 -->
            <div class="">
                <div class="fs-12" v-show="item.limitStr">{{item.limitStr}}</div>
                <div class="fs-11" v-show="item.max">{{item.max}}</div>
            </div>
            <!-- 小汪专享优惠券，仅为大商天狗app嵌套使用 -->
            <span class="pos-a top0 left0 fs-10 xiaowang-type-badge" v-if="item.xiaowangOnly && isHybrid" v-text="getTypeName(item.type)"></span>
        </div>
        <div v-if="item.countStr"
             class="pos-a text-white top-n10 paddingh50 paddingt20 text-center marginr-n50 right0 lh-16 couponsBadge"
             style="transform: rotate(45deg);-webkit-transform: rotate(45deg);-moz-transform: rotate(45deg);-o-transform: rotate(45deg);font-size: 10px;">
            {{item.countStr}}
        </div>
        <div class="flex1 paddingt20 paddingh20 bg-white xiaowang-only-coupon-content">
            <div class="flex-container top">
                <div class="flex1 lh-1 text-limit2" style="height: 28px;">
                        <span class="badge badge-radius badge-small fs-10 couponsBadge" style="padding: 2px 3px;"
                              v-text="getTypeName(item.type)" v-if="!item.xiaowangOnly || !isHybrid"></span>
                    <span class="fs-13 margint10 text-darker" v-text="item.title"></span>
                </div>
            </div>
            <div class="flex-container bottom marginv10" :class="{ 'xiaowang-only-btn': item.xiaowangOnly && isHybrid }">
                <div class="flex1"><span class="fs-11 text-light lh-1" v-text="item.time"></span></div>
                <!--狗粮换券-->
                <div class="badge badge-pill couponsBadge"
                     :style="item.receiveStatus ? 'min-width: 60px;' : 'min-width: 60px;background-color: #cccccc'"
                     @click="exchange(item)"
                     v-if="couponListType === 'dogFood'" data-scp="couponItemExchange.{{$index}}">
                        <span class="dis-i text-center fs-10" style="line-height: 14px">
                            <span v-text="!item.canReceived ?'已抢光':(item.payAmount+'狗粮兑换')"></span>
                        </span>
                </div>
                <!--券列表，无点击领取-->
                <div class="badge badge-pill couponsBadge" style="min-width: 60px"
                    v-if="couponListType === 'list' && item.clickUrl && item.useTag === 1" data-scp="couponList.{{$index}}"
                    @click="handleImmediateUse(item)"
                >
                    <span class="dis-i text-center fs-10" style="line-height: 14px">
                        <span>立即使用</span>
                    </span>
                </div>
                <!--券列表，点击领取-->
                <div class="badge badge-pill couponsBadge"
                     :style="item.receiveStatus ? 'min-width: 60px;' : 'min-width: 60px;background-color: #cccccc'"
                     @click="exchange(item)"
                     v-if="couponListType === 'get'" data-scp="couponItemExchange.{{$index}}">
                        <span class="dis-i text-center fs-10" style="line-height: 14px">
                            <span>{{item.btnText}}</span>
                        </span>
                </div>
	            <!-- 没有 clickUrl 非信息中心券 可用 现金、满减、折扣券 -->
	            <div class="badge badge-pill couponsBadge" style="min-width: 60px"
	                v-if="couponListType === 'list' && !item.clickUrl && item.platformTag === 1 && item.useTag === 1 && [1, 2, 3].indexOf(item.type) !== -1" data-scp="'couponProduct.{{$index}}"
                    @click="handleImmediateUse(item)"
                >
		            <!-- <a :href="'/search/searchResult.html?type=coupon&couponId='+item.couponSearchId"
		               :data-scp="'couponProduct.'+$index">
			            <div class="dis-i text-white text-center fs-10" style="line-height: 14px">
				            <span>立即使用</span>
			            </div>
		            </a> -->
                    <span class="dis-i text-center fs-10" style="line-height: 14px">
                        <span>立即使用</span>
                    </span>
	            </div>
            </div>
            <div class="flex-container top pos-r" v-if="isShowMore" @click="item.showMoreText = !item.showMoreText"
                 data-scp="couponItemShowMore.{{$index}}">
                <div v-if="!isHybrid || (isHybrid && !item.xiaowangOnly)">
                    <div class="flex1" v-if="couponListType === 'list' && item.platformTag == 2 && item.applyStoreNameList">
                    <div class="text-light fs-10 text-limit1" v-text="item.applyStoreNameList"
                            style="overflow:hidden;"></div>
                    </div>
                    <div class="flex1" v-else>
                        <div class="text-light fs-10 text-limit1" v-text="item.storeName"
                            style="overflow:hidden;"></div>
                    </div>
                </div>
                <div class="fs-11" style="color: #BF793D;" v-else>仅限在“我是小汪”小程序领取使用</div>
                <div class="text-right text-light lh-1" style="min-width: 20px;">
                    <i class="icon fs-16" :class="item.showMoreText?'icon-fold':'icon-unfold'"></i>
                </div>
            </div>
        </div>
    </div>
    <!-- 券详情 -->
    <div class="bg-white padding20" v-show="item.showMoreText">
        <div class="flex-container top">
            <div class="text-light paddingr10">适用范围：</div>
            <div class="flex1" v-if="couponListType === 'list' && item.platformTag == 2 && item.applyStoreList">
                <div class="text-dark" v-for="i in item.applyStoreList" v-text="i" ></div>
                <a :href="item.cityUrl"
                   v-if="item.cityUrl" data-scp="more.0">
	                <div class="text-blue">查看更多 ></div>
                </a>
            </div>
            <div class="flex1" v-else>
                <div class="text-dark" v-text="item.storeName"></div>
                <a :href="item.cityUrl"
                   v-if="item.cityUrl" data-scp="more.0">
	                <span class="text-blue">查看更多 ></span>
                </a>
            </div>
        </div>
        <div class="flex-container top" v-if="!(couponListType === 'list' && item.platformTag == 2)">
            <div class="text-light paddingr10">使用期限：</div>
            <div class="text-dark flex1" v-text="item.time"></div>
        </div>
        <div class="flex-container top">
            <div class="text-light paddingr10">使用详情：</div>
            <div class="flex1">
                <div class="text-dark flex1" v-html="item.detailContent"></div>
                <tg-barcode :content="item.code" :listen="false" class="box-span12 left"></tg-barcode>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {maple, domain, app} from 'tgPage';
import couponServer from '../../api/couponServer.js';
import memberServer from '../../api/member.js';

export default {
    props: {
        coupon: {
            type: Array,
            default: []
        },
        couponListType: {
            type: String,
            default: 'list'
        },
        isShowMore: {
          type: Boolean,
          default: true
        },
        goUseModal: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            // couponListType: this.couponListType
            isHybrid: maple.cookie('hybrid') === 'true'
        }
    },
    computed: {
        localCoupon() {
            let tempArr = [];
            this.coupon.map(function (item, index) {
                if (!item.canReceived && !item.totleRemainQty) {
                    item.btnText = "已抢光";
                    item.receiveStatus = false;
                } else if (!item.canReceived && item.totleRemainQty && !item.todayRemainQty) {
                    item.btnText = "明日再来";
                    item.receiveStatus = false;
                } else if (!item.canReceived && item.totleRemainQty && item.todayRemainQty) {
                    if (item.receivedQty >= item.limitQty){
                        item.btnText = "明日再来";
                        item.receiveStatus = false;
                    }else{
                        item.btnText = "已领取";
                        item.receiveStatus = false;
                    }
                } else if (item.canReceived) {
                    item.btnText = "立即领取";
                    item.receiveStatus = true;
                }
                tempArr.push(item)
            })
            return tempArr;
        }
    },
    methods: {
        getTypeName(item) {
            const TAG_NAME_LIST = {
                '1': '现金',
                '2': '折扣',
                '3': '满减',
                '4': '买送',
                '5': '单品',//已废弃
                '6': '单品',//已废弃
                '7': '信息',//已废弃
                '8': '停车',
                '9': '礼品',//保鲜礼
                '10': '抵值',
                '11': '打折',
                '14': '礼品',
                '15': '运费',
                '16': '克减',//黄金克减
                '17': '运费'//运费满减
            };

            return TAG_NAME_LIST[item]
        }
        , getColor(item){
            // useTag:  1-未使用；2-已使用；3-已过期；4-即将过期
            // platformTag:  1-天狗；2-信息中心
            if( item.receiveStatus || this.couponListType === 'list' ){
                return ((item.useTag === 2 || item.useTag === 3) ? 'couponsList3' : (item.platformTag === 2) ? 'couponsList2' : 'couponsList1');
            }
            else {
                return 'couponsList3';
            }
        }
        , exchange(item){
            const that = this;
            // if (item.xiaowangOnly && this.isHybrid) {
            //     const willGoWXPath = `pages/tiangoukuajing/tiangoukuajing?fromTGType=2&couponId=${item.id}&titleType=1`;
            //     app.startWxapp({
            //         userName: domain.overSea.userName,
            //         type: domain.overSea.type,
            //         path: willGoWXPath
            //     });
            // } else {
                item.receiveStatus && couponServer.couponCodeAdd({
                    data: {
                        couponId: item.id
                        , amount: item.payAmount
                    }
                    , success(data){
                        if (that.goUseModal) {
                            if (data.useWay === 2) {
                                // 只能线下使用
                                maple.notice(`领取成功，该优惠券门店线下使用`)
                            } else {
                                // 去落地页
                                maple.confirm({
                                    content: '<div class="text-center"><p style="font-size:20px;color:#000000;font-weight:500;margin-bottom: 5px;">领取成功</p><p>该权益已放入您的优惠券包</p></div>',
                                    okText: '立即使用',
                                    cancelText: '确定',
                                    okFn:() => {
                                        if (data.useUrl){
                                            maple.pageIns.changePage(data.useUrl)
                                        } else {
                                            maple.pageIns.changePage("../search/searchResult.html", { "type": "coupon", "couponId": item.id })
                                        }
                                    }
                                })
                            }
                        } else {
                            maple.notice('领取成功')
                        }
                    }
                    , tgError: (data)=>{
                        if( data.code === 1001 ){
                            let errorObj = JSON.parse( data.message )
                                ;

                            if( errorObj.code === 10001 ){
                                maple.confirm({
                                    content: errorObj.msg
                                    , cancelText: '取消'
                                    , cancelFn: ()=>{}
                                    , okText: '创建会员并领取'
                                    , okFn: ()=>{
                                        memberServer.createCard({
                                            data:{
                                                phone:maple.cookie('cellPhone'),
                                                storeId:item.storeIds[0]
                                            },
                                            success:function () {
                                                maple.notice('开通成功');
                                            },
                                            tgError:function () {
                                                maple.alert({
                                                    content:'当前店铺无法开通会员卡'
                                                })
                                            }
                                        });
                                    }
                                });
                            }
                            else if( errorObj.code === 10002 ){
                                maple.confirm({
                                    content: '<div class="text-center padding50"><img src="//image1.51tiangou.com/tgou2/img2/bg-cards.png" alt width="90"><div class="text-dark margint20">发现你有可用的会员卡，绑定会员卡即可享受积分和优惠活动，是否现在绑定？</div></div>'
                                    , cancelText: '取消'
                                    , cancelFn: ()=>{}
                                    , okText: '绑定'
                                    , okFn: ()=>{
                                        let cid = errorObj.cardInfo.cardId
                                            , groupId = errorObj.cardInfo.groupId
                                            ;

                                        memberServer.noValidate({
                                            data:{
                                                cid: cid
                                                , groupId: groupId
                                            },
                                            success: function(data){
                                                if( data ){
                                                    maple.notice('绑定成功，已获得电子会员特权');
                                                    setTimeout(function(){
                                                        location.reload();
                                                    }, 2000);
                                                }
                                                else{
                                                    maple.pageIns.changePage('../cards/bindcardinfo.html', {
                                                        cardId: cid
                                                        , groupId: groupId
                                                    });
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                            else{
                                maple.notice( errorObj.msg );
                            }
                        }
                        else{
                            if( data.code === 666 && this.couponListType === 'get' ){
                                let tpl = '领取失败' + '<br/>' + data.message
                                    ;

                                maple.notice(tpl, 'info');
                                item.receiveStatus = false;

                                if( data.message.indexOf('每日') > -1 ){
                                    item.btnText = '明日再来';
                                }
                                else if( data.message.indexOf('总数上限') > -1 ){
                                    item.btnText = '已抢光';
                                }
                                else if( data.message.indexOf('每人限领数上限') > -1 ){
                                    item.btnText = '已领取';
                                }
                            }
                            else{
                                maple.notice( data.message );
                            }
                        }
                    }
                });
            // }
        },
        handleImmediateUse (item) {
            // if (item.xiaowangOnly && this.isHybrid) {
            //     const willGoWXPath = !item.clickUrl
            //         ? `subpackages/customer/cuxiao/couponproducts/couponproducts?couponId=${item.couponSearchId}`
            //         : item.clickUrl.indexOf("alone") > 0
            //         ? `subpackages/customer/cuxiao/quandetail/quandetail?couponId=${item.couponSearchId}`
            //         : `subpackages/customer/cuxiao/couponproducts/couponproducts?couponId=${item.couponSearchId}`;
            //     app.startWxapp({
            //         userName: domain.overSea.userName,
            //         type: domain.overSea.type,
            //         path: willGoWXPath
            //     });
            // } else {
                if (item.clickUrl) {
                    maple.pageIns.changePage(item.clickUrl);
                } else {
                    maple.pageIns.changePage("../search/searchResult.html", { "type": "coupon", "couponId": item.couponSearchId });
                }
            // }
        }
    }
}
</script>

<style lang="scss">
.couponsList {
	overflow: hidden;
}

.couponsList .couponHeadContainer:after {
	position: absolute;
	content: '';
	width: 8px;
	height: 80px;
	background: radial-gradient(#fff 0px, #fff 2px, rgba(0, 0, 0, 0) 2px, rgba(0, 0, 0, 0) 2px);
	background-size: 9px 9px;
	background-position: -9px -9px;
	left: 96px;
	top: 7px;
}

.couponsList > div:first-child {
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
}

.couponsList > div:last-child {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.couponsList1:before,
.couponsList1:after {
	border: 1px solid #ff898c;
}

.couponsList1 > div {
	border: 1px solid #ff898c;
}

.couponsList1 .couponHeadContainer {
	background: #FF898C;
}

.couponsList1 .couponsBadge {
	background: #FF898C;
}

.couponsList2:before,
.couponsList2:after {
	border: 1px solid #ffbc59;
}

.couponsList2 > div {
	border: 1px solid #ffbc59;
}

.couponsList2 .couponHeadContainer {
	background: #ffbc59;
}

.couponsList2 .couponsBadge {
	background: #ffbc59;
}

.couponsList3:before,
.couponsList3:after {
	border: 1px solid #CCCCCC;
}

.couponsList3 > div {
	border: 1px solid #CCCCCC;
}

.couponsList3 .couponHeadContainer {
	background: #CCCCCC;
}

.couponsList3 .couponsBadge {
	background: #CCCCCC;
}

.xiaowang-only {
    background-image: url("//image1.51tiangou.com/tgou2/img2/coupon/xiaowang-only.png");
    background-size: auto 95px;
}
.xiaowang-only .couponHeadContainer {
    background-color: transparent;
    color: #BF793D;
    border: none;
}
.xiaowang-only .couponHeadContainer:after {
    display: none;
}
.xiaowang-only .xiaowang-only-coupon-content {
    background-color: transparent;
    border: none;
}
.xiaowang-only-btn > .couponsBadge {
    background-image: linear-gradient(90deg, #E6A46B 0%, #BF793D 100%) !important;
}
.xiaowang-type-badge {
    width: 34px;
    height: 16px;
    background: #BF793D 100%;
    text-align: center;
    border-radius: 4px 0 8px 0;
    color: #FFE9C4;
}
</style>